<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>心理治疗主题管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <div style="margin-right: 20px;">
                <el-button type="success" size="small" @click.native="clickAdd">添加主题</el-button>
            </div>
            <el-input v-model="searchParams.thematic" placeholder="搜索主题名称" style="width: 200px; margin-right: 10px;"
                @keyup.enter.native="getTaskList"></el-input>
        </div>
        <div class="list">
            <el-table :data="taskList" style="width: 100%" :row-class-name="tableRowClassName" size="mini"
                max-height="600" stripe>
                <el-table-column prop="id" label="主题id" fixed="left" width="150"></el-table-column>
                <el-table-column prop="thematic" label="主题名称"></el-table-column>
                <el-table-column prop="instructions" label="主题描述"></el-table-column>
                <el-table-column prop="ai_prompts" label="AI提示词"></el-table-column>
                <el-table-column prop="note" label="备注"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" circle
                            @click="clickEdit(scope.$index, scope.row)"></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle
                            @click="clickDelete(scope.$index, scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="delTaskList">删 除</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改数据" :visible.sync="dialogModifyData">
            <el-form :model="modifyData" :rules="rules" ref="modifyData">
                <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.id" disabled autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="主题名称" :label-width="formLabelWidth" prop="thematic">
                    <el-input v-model="modifyData.thematic" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="主题描述" :label-width="formLabelWidth" prop="instructions">
                    <el-input v-model="modifyData.instructions" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="AI提示词" :label-width="formLabelWidth" prop="ai_prompts">
                    <el-input v-model="modifyData.ai_prompts" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth" prop="note">
                    <el-input v-model="modifyData.note" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogModify">取 消</el-button>
                <el-button type="primary" @click="submitFormModify">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加数据" :visible.sync="dialogAddData">
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="主题名称" :label-width="formLabelWidth" prop="thematic">
                    <el-input v-model="addData.thematic" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="主题描述" :label-width="formLabelWidth" prop="instructions">
                    <el-input v-model="addData.instructions" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="AI提示词" :label-width="formLabelWidth" prop="ai_prompts">
                    <el-input v-model="addData.ai_prompts" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth" prop="note">
                    <el-input v-model="addData.note" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            searchParams: {
                thematic: ''
            },
            pages: 1,
            limit: 10,
            taskList: [],
            total: 0,
            dialogDelete: false,
            dialogModifyData: false,
            modifyData: {
                id: '',
                thematic: '',
                instructions: '',
                ai_prompts: '',
                note: ''
            },
            formLabelWidth: '120px',
            dialogAddData: false,
            addData: {
                thematic: '',
                instructions: '',
                ai_prompts: '',
                note: ''
            },
            rules: {
                thematic: [
                    { required: true, message: '主题名称为必填项', trigger: 'blur' }
                ]
            },
            delData: {}
        }
    },
    created() {
        this.getTaskList()
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            return rowIndex % 2 === 1 ? '' : 'success-row';
        },
        getTaskList() {
            // 构建查询参数
            let queryParams = `?&pages=${this.pages}&limit=${this.limit}`;
            if (this.searchParams.thematic) {
                queryParams += `&thematic=${this.searchParams.thematic}`;
            }

            this.$get(`/v1/thematic-healing-detail${queryParams}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.taskList = res.data.data || [];
                    this.total = res.data.total || 0;
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            this.limit = val;
            this.getTaskList();
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getTaskList();
        },
        clickEdit(index, row) {
            this.modifyData = { ...row };
            this.dialogModifyData = true;
        },
        clickDelete(index, row) {
            this.dialogDelete = true;
            this.delData = row;
        },
        delTaskList() {
            this.$delete(`/v1/thematic-healing-detail?id=${this.delData.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功');
                    this.getTaskList();
                } else {
                    this.$msg(res.data.msg);
                }
                this.dialogDelete = false;
            });
        },
        clickAdd() {
            this.dialogAddData = true;
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.addTaskList(this.addData);
                } else {
                    this.$message.error('表单验证失败!');
                    return false;
                }
            });
        },
        addTaskList(data) {
            this.$post('/v1/thematic-healing-detail', data).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('添加成功');
                    this.resetForm('addData');
                    this.getTaskList();
                    this.dialogAddData = false;
                } else {
                    this.$msg(res.data.msg);
                }
            });
        },
        closeDialogAdd() {
            this.dialogAddData = false;
            this.resetForm('addData');
        },
        closeDialogModify() {
            this.dialogModifyData = false;
            this.resetForm('modifyData');
        },
        submitFormModify() {
            this.$refs.modifyData.validate((valid) => {
                if (valid) {
                    this.modifyTaskList(this.modifyData);
                } else {
                    console.log('表单验证失败!');
                    return false;
                }
            });
        },
        modifyTaskList(data) {
            this.$put('/v1/thematic-healing-detail', data).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('修改成功');
                    this.getTaskList();
                    this.dialogModifyData = false;
                } else {
                    this.$msg(res.data.msg);
                }
            });
        },
        resetForm(formName) {
            const initialAddData = {
                thematic: '',
                instructions: '',
                ai_prompts: '',
                note: ''
            };
            const initialModifyData = {
                id: '',
                thematic: '',
                instructions: '',
                ai_prompts: '',
                note: ''
            };

            if (formName === 'addData') {
                this.addData = { ...initialAddData };
            } else if (formName === 'modifyData') {
                this.modifyData = { ...initialModifyData };
            }
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-list
      .el-table .success-row 
        background #f0f9eb
      
      .search
        margin 20px 0
        display flex
        justify-content flex-start
</style>


// WEBPACK FOOTER //
// src/pages/theme-Dialogue/theme-Dialogue.vue